import { render } from "./FathersForm.vue?vue&type=template&id=70127ea6"
import script from "./FathersForm.vue?vue&type=script&lang=js"
export * from "./FathersForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__